// extracted by mini-css-extract-plugin
export default {"votingBoard":"VotingBoard_votingBoard__wnBgy","voteCards":"VotingBoard_voteCards__3zzvk"};